import { render, staticRenderFns } from "./EditHeroUpgradeTaskDialog.vue?vue&type=template&id=0d522ac1&scoped=true"
import script from "./EditHeroUpgradeTaskDialog.vue?vue&type=script&lang=js"
export * from "./EditHeroUpgradeTaskDialog.vue?vue&type=script&lang=js"
import style0 from "./EditHeroUpgradeTaskDialog.vue?vue&type=style&index=0&id=0d522ac1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d522ac1",
  null
  
)

export default component.exports